import { showShareAssignmentModal } from '@module/assignment-components';
import { buildAssignmentShareUrl } from '../../../utils/assignment-url.util';
export var onShowAssignmentCreationSuccessModal = function onShowAssignmentCreationSuccessModal(_ref) {
  var assignmentInfo = _ref.assignmentInfo,
      assignmentCreationModalSharing = _ref.assignmentCreationModalSharing;
  var shareUrl = buildAssignmentShareUrl(assignmentInfo.id.toString(), assignmentInfo.title);
  showShareAssignmentModal({
    title: assignmentInfo.title,
    idNumber: assignmentInfo.idNumber,
    sharedLink: shareUrl,
    absoluteShareUrl: shareUrl,
    linkSectionLabel: assignmentCreationModalSharing.studentAccessLink || assignmentCreationModalSharing.shareAssignmentNow,
    qrCodeHint: assignmentCreationModalSharing.studentAccessQrHint,
    shareAssignmentTranslation: assignmentCreationModalSharing
  });
};